import { makeAutoObservable } from "mobx";
import {
  GET_PLATFORM,
  POST_PLATFORM,
  PUT_PLATFORM,
  DELETE_PLATFORM,
  GET_PLATFORM_USER,
} from "../apis/apis";
import { message } from "antd";

class CatalogueStore {
  constructor({ errStore }) {
    makeAutoObservable(this);
    this.errStore = errStore;
  }

  catalogueItems = [];
  catalogueCount = null;
  catalogueItem = null;
  isCatalogueModalOpen = false;
  user = {};
  updateModeOn = false;
  userProfile = null;

  setupdateModeOn = (value) => {
    this.updateModeOn = value;
  };

  setIsCatalogueModalOpen = (value) => {
    this.isCatalogueModalOpen = value;
  };

  setCatalogueItems = (value) => {
    this.catalogueItems = value;
  };

  setCatalogueCount = (value) => {
    this.catalogueCount = value;
  };

  setCatalogueItem = (value) => {
    this.catalogueItem = value;
  };

  setUser = (value) => {
    this.user = value;
  };

  setUserProfile = (value) => {
    this.userProfile = value;
  };

  catalogueDetails = [];

  SetCatalogueItemDetails = (record) => {
    this.catalogueDetails = [
      {
        name: ["title"],
        value: record.title,
      },
      {
        name: ["description"],
        value: record.description,
      },
      {
        name: ["type"],
        value: record.type,
      },
      {
        name: ["source"],
        value: record.source,
      },
    ];
  };

  GetCatalogueItems = async (page) => {
    this.errStore.setLoading(true);
    try {
      const data = await GET_PLATFORM(`/catalogue-item?page=${page}`);
      this.setCatalogueItems(data.results);
      this.setCatalogueCount(data.count);
      this.errStore.setMessage("");
    } catch (error) {
      console.log(error);
    } finally {
      this.errStore.setLoading(false);
    }
  };

  GetUser = () => {
    this.errStore.setLoading(true);
    GET_PLATFORM_USER(`/user`)
      .then((data) => {
        this.setUser(data);
        console.log(this.user);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        // this.errStore.handlerErrors(error);
        console.log(error);
      });
  };

  CreateCatalogueItem = async (values) => {
    this.errStore.setLoading(true);
    POST_PLATFORM(`/catalogue-item`, values)
      .then(async (data) => {
        let temp = this.catalogueItems;
        // unshift function used to add an element to the beggining of an array
        temp.unshift(data);
        this.setCatalogueItems(temp);
        this.setIsCatalogueModalOpen(false);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        message.success("Item created successfully");
        await this.GetCatalogueItems(1);
      })
      .catch((error) => {
        message.error("Something went wrong. Please try again.");
        this.errStore.handlerErrors(error);
      });
  };

  catalogueItemId = null;
  setCatalogueItemId = (value) => {
    this.catalogueItemId = value;
  };

  UpdateCatalogueItemById = async (values) => {
    try {
      const data = await PUT_PLATFORM(
        `/catalogue-item/${this.catalogueItemId}`,
        values,
      );

      this.errStore.setMessage("");
      this.setIsCatalogueModalOpen(false);
      this.setupdateModeOn(false);
      message.success("Item updated successfully");

      for (let i = 0; i < this.catalogueItems.length; i++) {
        if (this.catalogueItems[i].id === this.catalogueItemId) {
          this.catalogueItems[i] = data;
          break;
        }
      }

      this.GetCatalogueItems(1);
      await this.GetCatalogueById(this.catalogueItemId);
    } catch (err) {
      message.error("Something went wrong. Please try again.");
      this.errStore.handlerErrors(err);
    }
  };

  GetCatalogueById = async (id) => {
    this.errStore.setLoading(true);
    try {
      const data = await GET_PLATFORM(`/catalogue-item/${id}`);
      this.setCatalogueItem(data);
      this.setCatalogueItemId(data.id);
      this.errStore.setMessage("");
    } catch (error) {
      this.errStore.handlerErrors(error);
    }
  };

  GetProfileById = async (id) => {
    this.errStore.setLoading(true);
    try {
      const data = await GET_PLATFORM(`/profile/${id}`);
      this.setUserProfile(data);
      this.errStore.setMessage("");
    } catch (error) {
      this.errStore.handlerErrors(error);
    }
  };

  GetCatalogueByTitle = (title) => {
    this.errStore.setLoading(true);
    GET_PLATFORM(`/catalogue-item/title/${title}`)
      .then((data) => {
        // this.setCatalogueItems(data);
        this.setCatalogueItems(data.results);
        this.setCatalogueCount(data.count);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetCatalogueByType = (type) => {
    this.errStore.setLoading(true);
    GET_PLATFORM(`/catalogue-item/type/${type}`)
      .then((data) => {
        // this.setCatalogueItems(data);
        this.setCatalogueItems(data.results);
        this.setCatalogueCount(data.count);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  GetCatalogueItemsByTypeOrName = (values) => {
    this.errStore.setLoading(true);
    GET_PLATFORM(`/catalogue-item/${values.order}/${values.value}`)
      .then((data) => {
        // this.setMarketplaceItems(data);
        this.setCatalogueItems(data.results);
        this.setCatalogueCount(data.count);
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
      })
      .catch((error) => {
        this.errStore.handlerErrors(error);
      });
  };

  removeObjectWithId(arr, id) {
    const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
    arr.splice(objWithIdIndex, 1);
    return arr;
  }

  DeleteCatalogueItemById = (id) => {
    this.errStore.setLoading(true);
    DELETE_PLATFORM(`/catalogue-item/${id}`)
      .then((data) => {
        this.errStore.setMessage("");
        this.errStore.setLoading(false);
        this.setCatalogueItems(
          this.removeObjectWithId(this.catalogueItems, id),
        );
        message.success("Item deleted successfully");
        this.GetCatalogueItems(1);
      })
      .catch((error) => {
        message.error("Something went wrong. Please try again.");
        this.errStore.handlerErrors(error);
      });
  };
}

export default CatalogueStore;
